import React, { useEffect, useState } from 'react';
import { DesktopDateTimePicker } from '@mui/x-date-pickers';
import { TextField } from '@mui/material';
import { Title } from 'components/form-builder/widgets/Title';
import {
    endOfDay,
    format,
    formatISO,
    formatRFC3339,
    isValid,
    parseISO,
} from 'date-fns';
import get from 'lodash/get';

const CustomDateTimePickerField = (field, methods, f) => {
    const {
        formState: { errors, defaultValues },
        setValue,
        setError,
        clearErrors,
        trigger,
    } = methods;

    const { attribute, props } = field;

    const [dateError, setDateError] = useState(null);
    const [selectedDate, setSelectedDate] = useState('');

    useEffect(() => {
        if (
            !defaultValues[attribute] &&
            typeof defaultValues[attribute] === 'object'
        ) {
            setValue(attribute, '');
            return;
        } else if (!defaultValues[attribute]) return;
        setSelectedDate(defaultValues[attribute]);
    }, [defaultValues, attribute]);

    const handleDateChange = async (date, context) => {
        if (!isValid(date)) {
            setDateError('Invalid date');
            await trigger(attribute);
            return;
        }
        setDateError(null);
        setSelectedDate(format(new Date(date), "yyyy-MM-dd'T'HH:mm:ss"));
        setValue(attribute, format(new Date(date), "yyyy-MM-dd'T'HH:mm:ss"));
    };

    const handleBlur = () => {
        !dateError
            ? clearErrors(attribute)
            : setError(attribute, { message: 'Invalid date' });
    };

    return (
        <>
            <Title field={field}></Title>
            <DesktopDateTimePicker
                title={field?.title}
                value={selectedDate}
                disablePast={!defaultValues[attribute]}
                disableFuture={true}
                onChange={handleDateChange}
                inputFormat={props.inputFormat || 'HH:mm dd-MM-yyyy'}
                openTo={props.openTo || 'hours'}
                views={
                    props.views || [
                        'hours',
                        'minutes',
                        // "seconds",
                        'day',
                        'month',
                        'year',
                    ]
                }
                ampm={false}
                renderInput={params => (
                    <TextField
                        style={{ width: '100%' }}
                        {...params}
                        onBlur={handleBlur}
                        error={!!get(errors, attribute)}
                        helperText={get(errors, attribute)?.message}
                    />
                )}
            />
        </>
    );
};

export default CustomDateTimePickerField;
